"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../sass/theme.scss");
var svgxhr_1 = __importDefault(require("webpack-svgstore-plugin/src/helpers/svgxhr"));
require("lazysizes");
require("lazysizes/plugins/parent-fit/ls.parent-fit");
require("lazysizes/plugins/unveilhooks/ls.unveilhooks");
var vanilla_lazyload_1 = __importDefault(require("vanilla-lazyload"));
var scroll_lock_1 = require("scroll-lock");
var AccordionComponents_1 = __importDefault(require("./modules/AccordionComponents"));
var hover_block_1 = __importDefault(require("./modules/hover-block"));
var swiper_1 = __importDefault(require("swiper"));
var maps_1 = __importDefault(require("./modules/maps"));
var Dialog_1 = __importDefault(require("./modules/Dialog"));
var VideoGrid_1 = __importDefault(require("./modules/VideoGrid"));
var Nav_1 = __importDefault(require("./modules/Nav"));
// @ts-ignore
window.namespace = {
    init: function () {
        var _a;
        this.helpers.initSvg();
        var windowEl = window;
        new vanilla_lazyload_1.default();
        new AccordionComponents_1.default();
        new hover_block_1.default();
        new maps_1.default();
        var burger = document.querySelector("#burger");
        var close = document.querySelector("#close");
        var menu = document.querySelector("#menu");
        console.log("Burger: ", burger);
        if (burger) {
            burger.addEventListener('click', function (e) {
                console.log("Burger: ", burger);
                menu.classList.add('active');
                (0, scroll_lock_1.disablePageScroll)(menu);
            });
        }
        if (close) {
            close.addEventListener('click', function (e) {
                menu.classList.remove('active');
                (0, scroll_lock_1.enablePageScroll)(menu);
            });
        }
        var hoverSwipers = document.querySelectorAll('.c-hover-blocks__swiper');
        hoverSwipers.forEach(function (swiperEl) {
            console.log("Swiper el: ", swiperEl);
            var swiper = new swiper_1.default(swiperEl, {
                slidesPerView: 'auto',
            });
        });
        var videoGrids = document.querySelectorAll('.refsection--video-grid');
        videoGrids.forEach(function (videoGrid) {
            new VideoGrid_1.default(videoGrid);
        });
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
            if (!anchor.classList.contains(".dialog-trigger")) {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    var id = this.getAttribute('href');
                    var yOffset = -100;
                    var element = document.querySelector(id);
                    if (element) {
                        var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        if (menu) {
                            menu.classList.remove('active');
                            (0, scroll_lock_1.enablePageScroll)(menu);
                        }
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                });
            }
        });
        ((_a = document.querySelectorAll(".dialog-trigger")) !== null && _a !== void 0 ? _a : []).forEach(function (el) { return new Dialog_1.default(el); });
        var reformDialog = document.querySelector("#reform-dialog");
        if (reformDialog !== null) {
            if (document.cookie.split(';').filter(function (item) { return item.trim().startsWith('reform_modal='); }).length == 0) {
                reformDialog.showModal();
                var expiry = new Date();
                expiry.setTime(expiry.getTime() + (24 * 60 * 60 * 1000)); // 1 day
                document.cookie = "reform_modal=1; expires=" + expiry.toUTCString();
            }
            reformDialog.addEventListener("click", function (event) {
                var rect = reformDialog.getBoundingClientRect();
                var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                    rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
                if (!isInDialog) {
                    reformDialog.close();
                }
            });
        }
        var nav = document.getElementById("nav");
        if (nav) {
            new Nav_1.default(nav);
        }
    },
    helpers: {
        requireAll: function (r) {
            r.keys().forEach(r);
        },
        initSvg: function () {
            // @ts-ignore
            (0, svgxhr_1.default)({
                filename: './wp-content/themes/class/dist/sprite.svg', //URL to fetch
            });
        }
    }
};
// @ts-ignore
window.namespace.init();
// @ts-ignore
window.namespace.helpers.requireAll(require.context('../images/icons/', true, /\.svg$/));
